<div class="cell shrink" *ngIf="teamsData">
    <table class="_tableColor">
        <tbody>
        <tr class="_titlePartTable">
            <td [i18nKey]="'common.team'"></td>
            <td [i18nKey]="'studies.competitive.intelligence.trade.name'"></td>
            <td [i18nKey]="'common.area'"></td>
            <td [i18nKey]="'common.restaurant.type'"></td>
            <td class="_number" [i18nKey]="teamValueLabelKey"></td>
        </tr>
        <tr *ngFor="let teamData of teamsData">
            <td>{{teamData.teamNumber}}</td>
            <td>{{teamData.teamName}}</td>
            <td>{{'common.area.' + teamData.teamArea | translate}}</td>
            <td>{{'common.restaurant.type.' + teamData.teamRestaurantType | translate}}</td>
            <td *ngIf="!!teamData.teamValue" class="_number">{{teamData.teamValue | number:'1.2'}}</td>
            <td *ngIf="!teamData.teamValue" class="_number"[i18nKey]="'studies.competitive.intelligence.missing'"></td>
        </tr>
        </tbody>
    </table>
</div>
